<template>
    <div class="mini-overlay" tabindex="0" ref="root" @keydown.esc="close">
        <div class="mini-card">
            <div class="mini-header">
                <div>Flag Match — Score: {{ score }} / {{ targetScore }}</div>
            </div>

            <div class="flag-area">
                <img v-if="currentImage" :src="currentImage" class="flag-img" alt="flag" />
            </div>

            <div class="options">
                <button v-for="(opt, i) in options" :key="i"
                    :class="['opt-btn', { correct: feedback === 'correct' && opt === correct.name, wrong: feedback === 'wrong' && selected === opt }]"
                    @click="choose(opt)">
                    {{ opt }}
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'FlagMatchGame',
    emits: ['done', 'close'],
    props: {
        targetScore: { type: Number, default: 5 }
    },
    data() {

        const pool = [
            /* Länder */
            { code: 'ad', name: 'Andorra', image: require('@/assets/flags/country/ad.png') },
            { code: 'ae', name: 'Vereinigte Arabische Emirate', image: require('@/assets/flags/country/ae.png') },
            { code: 'af', name: 'Afghanistan', image: require('@/assets/flags/country/af.png') },
            { code: 'ag', name: 'Antigua und Barbuda', image: require('@/assets/flags/country/ag.png') },
            { code: 'ai', name: 'Anguilla', image: require('@/assets/flags/country/ai.png') },
            { code: 'al', name: 'Albanien', image: require('@/assets/flags/country/al.png') },
            { code: 'am', name: 'Armenien', image: require('@/assets/flags/country/am.png') },
            { code: 'ao', name: 'Angola', image: require('@/assets/flags/country/ao.png') },
            { code: 'aq', name: 'Antarktis', image: require('@/assets/flags/country/aq.png') },
            { code: 'ar', name: 'Argentinien', image: require('@/assets/flags/country/ar.png') },
            { code: 'as', name: 'Amerikanisch-Samoa', image: require('@/assets/flags/country/as.png') },
            { code: 'at', name: 'Österreich', image: require('@/assets/flags/country/at.png') },
            { code: 'au', name: 'Australien', image: require('@/assets/flags/country/au.png') },
            { code: 'aw', name: 'Aruba', image: require('@/assets/flags/country/aw.png') },
            { code: 'ax', name: 'Ålandinseln', image: require('@/assets/flags/country/ax.png') },
            { code: 'az', name: 'Aserbaidschan', image: require('@/assets/flags/country/az.png') },
            { code: 'ba', name: 'Bosnien und Herzegowina', image: require('@/assets/flags/country/ba.png') },
            { code: 'bb', name: 'Barbados', image: require('@/assets/flags/country/bb.png') },
            { code: 'bd', name: 'Bangladesch', image: require('@/assets/flags/country/bd.png') },
            { code: 'be', name: 'Belgien', image: require('@/assets/flags/country/be.png') },
            { code: 'bf', name: 'Burkina Faso', image: require('@/assets/flags/country/bf.png') },
            { code: 'bg', name: 'Bulgarien', image: require('@/assets/flags/country/bg.png') },
            { code: 'bh', name: 'Bahrain', image: require('@/assets/flags/country/bh.png') },
            { code: 'bi', name: 'Burundi', image: require('@/assets/flags/country/bi.png') },
            { code: 'bj', name: 'Benin', image: require('@/assets/flags/country/bj.png') },
            { code: 'bl', name: 'Saint-Barthélemy', image: require('@/assets/flags/country/bl.png') },
            { code: 'bm', name: 'Bermuda', image: require('@/assets/flags/country/bm.png') },
            { code: 'bn', name: 'Brunei', image: require('@/assets/flags/country/bn.png') },
            { code: 'bo', name: 'Bolivien', image: require('@/assets/flags/country/bo.png') },
            { code: 'bq', name: 'Karibische Niederlande', image: require('@/assets/flags/country/bq.png') },
            { code: 'br', name: 'Brasilien', image: require('@/assets/flags/country/br.png') },
            { code: 'bs', name: 'Bahamas', image: require('@/assets/flags/country/bs.png') },
            { code: 'bt', name: 'Bhutan', image: require('@/assets/flags/country/bt.png') },
            { code: 'bv', name: 'Bouvetinsel', image: require('@/assets/flags/country/bv.png') },
            { code: 'bw', name: 'Botswana', image: require('@/assets/flags/country/bw.png') },
            { code: 'by', name: 'Belarus', image: require('@/assets/flags/country/by.png') },
            { code: 'bz', name: 'Belize', image: require('@/assets/flags/country/bz.png') },
            { code: 'ca', name: 'Kanada', image: require('@/assets/flags/country/ca.png') },
            { code: 'cc', name: 'Kokosinseln (Keeling)', image: require('@/assets/flags/country/cc.png') },
            { code: 'cd', name: 'Demokratische Republik Kongo', image: require('@/assets/flags/country/cd.png') },
            { code: 'cf', name: 'Zentralafrikanische Republik', image: require('@/assets/flags/country/cf.png') },
            { code: 'cg', name: 'Republik Kongo', image: require('@/assets/flags/country/cg.png') },
            { code: 'ch', name: 'Schweiz', image: require('@/assets/flags/country/ch.png') },
            { code: 'ci', name: 'Elfenbeinküste', image: require('@/assets/flags/country/ci.png') },
            { code: 'ck', name: 'Cookinseln', image: require('@/assets/flags/country/ck.png') },
            { code: 'cl', name: 'Chile', image: require('@/assets/flags/country/cl.png') },
            { code: 'cm', name: 'Kamerun', image: require('@/assets/flags/country/cm.png') },
            { code: 'cn', name: 'China', image: require('@/assets/flags/country/cn.png') },
            { code: 'co', name: 'Kolumbien', image: require('@/assets/flags/country/co.png') },
            { code: 'cr', name: 'Costa Rica', image: require('@/assets/flags/country/cr.png') },
            { code: 'cu', name: 'Kuba', image: require('@/assets/flags/country/cu.png') },
            { code: 'cv', name: 'Kap Verde', image: require('@/assets/flags/country/cv.png') },
            { code: 'cw', name: 'Curaçao', image: require('@/assets/flags/country/cw.png') },
            { code: 'cx', name: 'Weihnachtsinsel', image: require('@/assets/flags/country/cx.png') },
            { code: 'cy', name: 'Zypern', image: require('@/assets/flags/country/cy.png') },
            { code: 'cz', name: 'Tschechien', image: require('@/assets/flags/country/cz.png') },
            { code: 'de', name: 'Deutschland', image: require('@/assets/flags/country/de.png') },
            { code: 'dj', name: 'Dschibuti', image: require('@/assets/flags/country/dj.png') },
            { code: 'dk', name: 'Dänemark', image: require('@/assets/flags/country/dk.png') },
            { code: 'dm', name: 'Dominica', image: require('@/assets/flags/country/dm.png') },
            { code: 'do', name: 'Dominikanische Republik', image: require('@/assets/flags/country/do.png') },
            { code: 'dz', name: 'Algerien', image: require('@/assets/flags/country/dz.png') },
            { code: 'ec', name: 'Ecuador', image: require('@/assets/flags/country/ec.png') },
            { code: 'ee', name: 'Estland', image: require('@/assets/flags/country/ee.png') },
            { code: 'eg', name: 'Ägypten', image: require('@/assets/flags/country/eg.png') },
            { code: 'eh', name: 'Westsahara', image: require('@/assets/flags/country/eh.png') },
            { code: 'er', name: 'Eritrea', image: require('@/assets/flags/country/er.png') },
            { code: 'es', name: 'Spanien', image: require('@/assets/flags/country/es.png') },
            { code: 'et', name: 'Äthiopien', image: require('@/assets/flags/country/et.png') },
            { code: 'fi', name: 'Finnland', image: require('@/assets/flags/country/fi.png') },
            { code: 'fj', name: 'Fidschi', image: require('@/assets/flags/country/fj.png') },
            { code: 'fk', name: 'Falklandinseln', image: require('@/assets/flags/country/fk.png') },
            { code: 'fm', name: 'Mikronesien', image: require('@/assets/flags/country/fm.png') },
            { code: 'fo', name: 'Färöer', image: require('@/assets/flags/country/fo.png') },
            { code: 'fr', name: 'Frankreich', image: require('@/assets/flags/country/fr.png') },
            { code: 'ga', name: 'Gabon', image: require('@/assets/flags/country/ga.png') },
            { code: 'gb-eng', name: 'England', image: require('@/assets/flags/country/gb-eng.png') },
            { code: 'gb-nir', name: 'Nordirland', image: require('@/assets/flags/country/gb-nir.png') },
            { code: 'gb-sct', name: 'Schottland', image: require('@/assets/flags/country/gb-sct.png') },
            { code: 'gb-wls', name: 'Wales', image: require('@/assets/flags/country/gb-wls.png') },
            { code: 'gb', name: 'Vereinigtes Königreich', image: require('@/assets/flags/country/gb.png') },
            { code: 'gd', name: 'Grenada', image: require('@/assets/flags/country/gd.png') },
            { code: 'ge', name: 'Georgien', image: require('@/assets/flags/country/ge.png') },
            { code: 'gf', name: 'Französisch-Guayana', image: require('@/assets/flags/country/gf.png') },
            { code: 'gg', name: 'Guernsey', image: require('@/assets/flags/country/gg.png') },
            { code: 'gh', name: 'Ghana', image: require('@/assets/flags/country/gh.png') },
            { code: 'gi', name: 'Gibraltar', image: require('@/assets/flags/country/gi.png') },
            { code: 'gl', name: 'Grönland', image: require('@/assets/flags/country/gl.png') },
            { code: 'gm', name: 'Gambia', image: require('@/assets/flags/country/gm.png') },
            { code: 'gn', name: 'Guinea', image: require('@/assets/flags/country/gn.png') },
            { code: 'gp', name: 'Guadeloupe', image: require('@/assets/flags/country/gp.png') },
            { code: 'gq', name: 'Äquatorialguinea', image: require('@/assets/flags/country/gq.png') },
            { code: 'gr', name: 'Griechenland', image: require('@/assets/flags/country/gr.png') },
            { code: 'gs', name: 'Südgeorgien und Südliche Sandwichinseln', image: require('@/assets/flags/country/gs.png') },
            { code: 'gt', name: 'Guatemala', image: require('@/assets/flags/country/gt.png') },
            { code: 'gu', name: 'Guam', image: require('@/assets/flags/country/gu.png') },
            { code: 'gw', name: 'Guinea-Bissau', image: require('@/assets/flags/country/gw.png') },
            { code: 'gy', name: 'Guyana', image: require('@/assets/flags/country/gy.png') },
            { code: 'hk', name: 'Hongkong', image: require('@/assets/flags/country/hk.png') },
            { code: 'hm', name: 'Heard- und McDonald-Inseln', image: require('@/assets/flags/country/hm.png') },
            { code: 'hn', name: 'Honduras', image: require('@/assets/flags/country/hn.png') },
            { code: 'hr', name: 'Kroatien', image: require('@/assets/flags/country/hr.png') },
            { code: 'ht', name: 'Haiti', image: require('@/assets/flags/country/ht.png') },
            { code: 'hu', name: 'Ungarn', image: require('@/assets/flags/country/hu.png') },
            { code: 'id', name: 'Indonesien', image: require('@/assets/flags/country/id.png') },
            { code: 'ie', name: 'Irland', image: require('@/assets/flags/country/ie.png') },
            { code: 'il', name: 'Israel', image: require('@/assets/flags/country/il.png') },
            { code: 'im', name: 'Isle of Man', image: require('@/assets/flags/country/im.png') },
            { code: 'in', name: 'Indien', image: require('@/assets/flags/country/in.png') },
            { code: 'io', name: 'Britisches Territorium im Indischen Ozean', image: require('@/assets/flags/country/io.png') },
            { code: 'iq', name: 'Irak', image: require('@/assets/flags/country/iq.png') },
            { code: 'ir', name: 'Iran', image: require('@/assets/flags/country/ir.png') },
            { code: 'is', name: 'Island', image: require('@/assets/flags/country/is.png') },
            { code: 'it', name: 'Italien', image: require('@/assets/flags/country/it.png') },
            { code: 'je', name: 'Jersey', image: require('@/assets/flags/country/je.png') },
            { code: 'jm', name: 'Jamaika', image: require('@/assets/flags/country/jm.png') },
            { code: 'jo', name: 'Jordanien', image: require('@/assets/flags/country/jo.png') },
            { code: 'jp', name: 'Japan', image: require('@/assets/flags/country/jp.png') },
            { code: 'ke', name: 'Kenia', image: require('@/assets/flags/country/ke.png') },
            { code: 'kg', name: 'Kirgisistan', image: require('@/assets/flags/country/kg.png') },
            { code: 'kh', name: 'Kambodscha', image: require('@/assets/flags/country/kh.png') },
            { code: 'ki', name: 'Kiribati', image: require('@/assets/flags/country/ki.png') },
            { code: 'km', name: 'Komoren', image: require('@/assets/flags/country/km.png') },
            { code: 'kn', name: 'St. Kitts und Nevis', image: require('@/assets/flags/country/kn.png') },
            { code: 'kp', name: 'Nordkorea', image: require('@/assets/flags/country/kp.png') },
            { code: 'kr', name: 'Südkorea', image: require('@/assets/flags/country/kr.png') },
            { code: 'kw', name: 'Kuwait', image: require('@/assets/flags/country/kw.png') },
            { code: 'ky', name: 'Kaimaninseln', image: require('@/assets/flags/country/ky.png') },
            { code: 'kz', name: 'Kasachstan', image: require('@/assets/flags/country/kz.png') },
            { code: 'la', name: 'Laos', image: require('@/assets/flags/country/la.png') },
            { code: 'lb', name: 'Libanon', image: require('@/assets/flags/country/lb.png') },
            { code: 'lc', name: 'St. Lucia', image: require('@/assets/flags/country/lc.png') },
            { code: 'li', name: 'Liechtenstein', image: require('@/assets/flags/country/li.png') },
            { code: 'lk', name: 'Sri Lanka', image: require('@/assets/flags/country/lk.png') },
            { code: 'lr', name: 'Liberia', image: require('@/assets/flags/country/lr.png') },
            { code: 'ls', name: 'Lesotho', image: require('@/assets/flags/country/ls.png') },
            { code: 'lt', name: 'Litauen', image: require('@/assets/flags/country/lt.png') },
            { code: 'lu', name: 'Luxemburg', image: require('@/assets/flags/country/lu.png') },
            { code: 'lv', name: 'Lettland', image: require('@/assets/flags/country/lv.png') },
            { code: 'ly', name: 'Libyen', image: require('@/assets/flags/country/ly.png') },
            { code: 'ma', name: 'Marokko', image: require('@/assets/flags/country/ma.png') },
            { code: 'mc', name: 'Monaco', image: require('@/assets/flags/country/mc.png') },
            { code: 'md', name: 'Moldau', image: require('@/assets/flags/country/md.png') },
            { code: 'me', name: 'Montenegro', image: require('@/assets/flags/country/me.png') },
            { code: 'mf', name: 'Saint Martin', image: require('@/assets/flags/country/mf.png') },
            { code: 'mg', name: 'Madagaskar', image: require('@/assets/flags/country/mg.png') },
            { code: 'mh', name: 'Marshallinseln', image: require('@/assets/flags/country/mh.png') },
            { code: 'mk', name: 'Nordmazedonien', image: require('@/assets/flags/country/mk.png') },
            { code: 'ml', name: 'Mali', image: require('@/assets/flags/country/ml.png') },
            { code: 'mm', name: 'Myanmar', image: require('@/assets/flags/country/mm.png') },
            { code: 'mn', name: 'Mongolei', image: require('@/assets/flags/country/mn.png') },
            { code: 'mo', name: 'Macau', image: require('@/assets/flags/country/mo.png') },
            { code: 'mp', name: 'Nördliche Marianen', image: require('@/assets/flags/country/mp.png') },
            { code: 'mq', name: 'Martinique', image: require('@/assets/flags/country/mq.png') },
            { code: 'mr', name: 'Mauretanien', image: require('@/assets/flags/country/mr.png') },
            { code: 'ms', name: 'Montserrat', image: require('@/assets/flags/country/ms.png') },
            { code: 'mt', name: 'Malta', image: require('@/assets/flags/country/mt.png') },
            { code: 'mu', name: 'Mauritius', image: require('@/assets/flags/country/mu.png') },
            { code: 'mv', name: 'Malediven', image: require('@/assets/flags/country/mv.png') },
            { code: 'mw', name: 'Malawi', image: require('@/assets/flags/country/mw.png') },
            { code: 'mx', name: 'Mexiko', image: require('@/assets/flags/country/mx.png') },
            { code: 'my', name: 'Malaysia', image: require('@/assets/flags/country/my.png') },
            { code: 'mz', name: 'Mosambik', image: require('@/assets/flags/country/mz.png') },
            { code: 'na', name: 'Namibia', image: require('@/assets/flags/country/na.png') },
            { code: 'nc', name: 'Neukaledonien', image: require('@/assets/flags/country/nc.png') },
            { code: 'ne', name: 'Niger', image: require('@/assets/flags/country/ne.png') },
            { code: 'nf', name: 'Norfolkinsel', image: require('@/assets/flags/country/nf.png') },
            { code: 'ng', name: 'Nigeria', image: require('@/assets/flags/country/ng.png') },
            { code: 'ni', name: 'Nicaragua', image: require('@/assets/flags/country/ni.png') },
            { code: 'nl', name: 'Niederlande', image: require('@/assets/flags/country/nl.png') },
            { code: 'no', name: 'Norwegen', image: require('@/assets/flags/country/no.png') },
            { code: 'np', name: 'Nepal', image: require('@/assets/flags/country/np.png') },
            { code: 'nr', name: 'Nauru', image: require('@/assets/flags/country/nr.png') },
            { code: 'nu', name: 'Niue', image: require('@/assets/flags/country/nu.png') },
            { code: 'nz', name: 'Neuseeland', image: require('@/assets/flags/country/nz.png') },
            { code: 'om', name: 'Oman', image: require('@/assets/flags/country/om.png') },
            { code: 'pa', name: 'Panama', image: require('@/assets/flags/country/pa.png') },
            { code: 'pe', name: 'Peru', image: require('@/assets/flags/country/pe.png') },
            { code: 'pf', name: 'Französisch-Polynesien', image: require('@/assets/flags/country/pf.png') },
            { code: 'pg', name: 'Papua-Neuguinea', image: require('@/assets/flags/country/pg.png') },
            { code: 'ph', name: 'Philippinen', image: require('@/assets/flags/country/ph.png') },
            { code: 'pk', name: 'Pakistan', image: require('@/assets/flags/country/pk.png') },
            { code: 'pl', name: 'Polen', image: require('@/assets/flags/country/pl.png') },
            { code: 'pm', name: 'Saint-Pierre und Miquelon', image: require('@/assets/flags/country/pm.png') },
            { code: 'pn', name: 'Pitcairninseln', image: require('@/assets/flags/country/pn.png') },
            { code: 'pr', name: 'Puerto Rico', image: require('@/assets/flags/country/pr.png') },
            { code: 'ps', name: 'Palästina', image: require('@/assets/flags/country/ps.png') },
            { code: 'pt', name: 'Portugal', image: require('@/assets/flags/country/pt.png') },
            { code: 'pw', name: 'Palau', image: require('@/assets/flags/country/pw.png') },
            { code: 'py', name: 'Paraguay', image: require('@/assets/flags/country/py.png') },
            { code: 'qa', name: 'Katar', image: require('@/assets/flags/country/qa.png') },
            { code: 're', name: 'Réunion', image: require('@/assets/flags/country/re.png') },
            { code: 'ro', name: 'Rumänien', image: require('@/assets/flags/country/ro.png') },
            { code: 'rs', name: 'Serbien', image: require('@/assets/flags/country/rs.png') },
            { code: 'ru', name: 'Russland', image: require('@/assets/flags/country/ru.png') },
            { code: 'rw', name: 'Ruanda', image: require('@/assets/flags/country/rw.png') },
            { code: 'sa', name: 'Saudi-Arabien', image: require('@/assets/flags/country/sa.png') },
            { code: 'sb', name: 'Salomonen', image: require('@/assets/flags/country/sb.png') },
            { code: 'sc', name: 'Seychellen', image: require('@/assets/flags/country/sc.png') },
            { code: 'sd', name: 'Sudan', image: require('@/assets/flags/country/sd.png') },
            { code: 'se', name: 'Schweden', image: require('@/assets/flags/country/se.png') },
            { code: 'sg', name: 'Singapur', image: require('@/assets/flags/country/sg.png') },
            { code: 'sh', name: 'St. Helena', image: require('@/assets/flags/country/sh.png') },
            { code: 'si', name: 'Slowenien', image: require('@/assets/flags/country/si.png') },
            { code: 'sj', name: 'Svalbard und Jan Mayen', image: require('@/assets/flags/country/sj.png') },
            { code: 'sk', name: 'Slowakei', image: require('@/assets/flags/country/sk.png') },
            { code: 'sl', name: 'Sierra Leone', image: require('@/assets/flags/country/sl.png') },
            { code: 'sm', name: 'San Marino', image: require('@/assets/flags/country/sm.png') },
            { code: 'sn', name: 'Senegal', image: require('@/assets/flags/country/sn.png') },
            { code: 'so', name: 'Somalia', image: require('@/assets/flags/country/so.png') },
            { code: 'sr', name: 'Suriname', image: require('@/assets/flags/country/sr.png') },
            { code: 'ss', name: 'Südsudan', image: require('@/assets/flags/country/ss.png') },
            { code: 'st', name: 'São Tomé und Príncipe', image: require('@/assets/flags/country/st.png') },
            { code: 'sv', name: 'El Salvador', image: require('@/assets/flags/country/sv.png') },
            { code: 'sx', name: 'Sint Maarten', image: require('@/assets/flags/country/sx.png') },
            { code: 'sy', name: 'Syrien', image: require('@/assets/flags/country/sy.png') },
            { code: 'sz', name: 'Eswatini', image: require('@/assets/flags/country/sz.png') },
            { code: 'tc', name: 'Turks- und Caicosinseln', image: require('@/assets/flags/country/tc.png') },
            { code: 'td', name: 'Tschad', image: require('@/assets/flags/country/td.png') },
            { code: 'tf', name: 'Französische Süd- und Antarktisgebiete', image: require('@/assets/flags/country/tf.png') },
            { code: 'tg', name: 'Togo', image: require('@/assets/flags/country/tg.png') },
            { code: 'th', name: 'Thailand', image: require('@/assets/flags/country/th.png') },
            { code: 'tj', name: 'Tadschikistan', image: require('@/assets/flags/country/tj.png') },
            { code: 'tk', name: 'Tokelau', image: require('@/assets/flags/country/tk.png') },
            { code: 'tl', name: 'Osttimor', image: require('@/assets/flags/country/tl.png') },
            { code: 'tm', name: 'Turkmenistan', image: require('@/assets/flags/country/tm.png') },
            { code: 'tn', name: 'Tunesien', image: require('@/assets/flags/country/tn.png') },
            { code: 'to', name: 'Tonga', image: require('@/assets/flags/country/to.png') },
            { code: 'tr', name: 'Türkei', image: require('@/assets/flags/country/tr.png') },
            { code: 'tt', name: 'Trinidad und Tobago', image: require('@/assets/flags/country/tt.png') },
            { code: 'tv', name: 'Tuvalu', image: require('@/assets/flags/country/tv.png') },
            { code: 'tw', name: 'Taiwan', image: require('@/assets/flags/country/tw.png') },
            { code: 'tz', name: 'Tansania', image: require('@/assets/flags/country/tz.png') },
            { code: 'ua', name: 'Ukraine', image: require('@/assets/flags/country/ua.png') },
            { code: 'ug', name: 'Uganda', image: require('@/assets/flags/country/ug.png') },
            { code: 'us', name: 'Vereinigte Staaten', image: require('@/assets/flags/country/us.png') },
            { code: 'uy', name: 'Uruguay', image: require('@/assets/flags/country/uy.png') },
            { code: 'uz', name: 'Usbekistan', image: require('@/assets/flags/country/uz.png') },
            { code: 'va', name: 'Vatikanstadt', image: require('@/assets/flags/country/va.png') },
            { code: 'vc', name: 'St. Vincent und die Grenadinen', image: require('@/assets/flags/country/vc.png') },
            { code: 've', name: 'Venezuela', image: require('@/assets/flags/country/ve.png') },
            { code: 'vg', name: 'Britische Jungferninseln', image: require('@/assets/flags/country/vg.png') },
            { code: 'vi', name: 'US-Jungferninseln', image: require('@/assets/flags/country/vi.png') },
            { code: 'vn', name: 'Vietnam', image: require('@/assets/flags/country/vn.png') },
            { code: 'vu', name: 'Vanuatu', image: require('@/assets/flags/country/vu.png') },
            { code: 'wf', name: 'Wallis und Futuna', image: require('@/assets/flags/country/wf.png') },
            { code: 'ws', name: 'Samoa', image: require('@/assets/flags/country/ws.png') },
            { code: 'xk', name: 'Kosovo', image: require('@/assets/flags/country/xk.png') },
            { code: 'ye', name: 'Jemen', image: require('@/assets/flags/country/ye.png') },
            { code: 'yt', name: 'Mayotte', image: require('@/assets/flags/country/yt.png') },
            { code: 'za', name: 'Südafrika', image: require('@/assets/flags/country/za.png') },
            { code: 'zm', name: 'Sambia', image: require('@/assets/flags/country/zm.png') },
            { code: 'zw', name: 'Simbabwe', image: require('@/assets/flags/country/zw.png') },
            /* US */
            { code: 'ak', name: 'Alaska', image: require('@/assets/flags/us/ak.png') },
            { code: 'al', name: 'Alabama', image: require('@/assets/flags/us/al.png') },
            { code: 'ar', name: 'Arkansas', image: require('@/assets/flags/us/ar.png') },
            { code: 'az', name: 'Arizona', image: require('@/assets/flags/us/az.png') },
            { code: 'ca', name: 'California', image: require('@/assets/flags/us/ca.png') },
            { code: 'co', name: 'Colorado', image: require('@/assets/flags/us/co.png') },
            { code: 'ct', name: 'Connecticut', image: require('@/assets/flags/us/ct.png') },
            { code: 'de', name: 'Delaware', image: require('@/assets/flags/us/de.png') },
            { code: 'fl', name: 'Florida', image: require('@/assets/flags/us/fl.png') },
            { code: 'ga', name: 'Georgia', image: require('@/assets/flags/us/ga.png') },
            { code: 'hi', name: 'Hawaii', image: require('@/assets/flags/us/hi.png') },
            { code: 'ia', name: 'Iowa', image: require('@/assets/flags/us/ia.png') },
            { code: 'id', name: 'Idaho', image: require('@/assets/flags/us/id.png') },
            { code: 'il', name: 'Illinois', image: require('@/assets/flags/us/il.png') },
            { code: 'in', name: 'Indiana', image: require('@/assets/flags/us/in.png') },
            { code: 'ks', name: 'Kansas', image: require('@/assets/flags/us/ks.png') },
            { code: 'ky', name: 'Kentucky', image: require('@/assets/flags/us/ky.png') },
            { code: 'la', name: 'Louisiana', image: require('@/assets/flags/us/la.png') },
            { code: 'ma', name: 'Massachusetts', image: require('@/assets/flags/us/ma.png') },
            { code: 'md', name: 'Maryland', image: require('@/assets/flags/us/md.png') },
            { code: 'me', name: 'Maine', image: require('@/assets/flags/us/me.png') },
            { code: 'mi', name: 'Michigan', image: require('@/assets/flags/us/mi.png') },
            { code: 'mn', name: 'Minnesota', image: require('@/assets/flags/us/mn.png') },
            { code: 'mo', name: 'Missouri', image: require('@/assets/flags/us/mo.png') },
            { code: 'ms', name: 'Mississippi', image: require('@/assets/flags/us/ms.png') },
            { code: 'mt', name: 'Montana', image: require('@/assets/flags/us/mt.png') },
            { code: 'nc', name: 'North Carolina', image: require('@/assets/flags/us/nc.png') },
            { code: 'nd', name: 'North Dakota', image: require('@/assets/flags/us/nd.png') },
            { code: 'ne', name: 'Nebraska', image: require('@/assets/flags/us/ne.png') },
            { code: 'nh', name: 'New Hampshire', image: require('@/assets/flags/us/nh.png') },
            { code: 'nj', name: 'New Jersey', image: require('@/assets/flags/us/nj.png') },
            { code: 'nm', name: 'New Mexico', image: require('@/assets/flags/us/nm.png') },
            { code: 'nv', name: 'Nevada', image: require('@/assets/flags/us/nv.png') },
            { code: 'ny', name: 'New York', image: require('@/assets/flags/us/ny.png') },
            { code: 'oh', name: 'Ohio', image: require('@/assets/flags/us/oh.png') },
            { code: 'ok', name: 'Oklahoma', image: require('@/assets/flags/us/ok.png') },
            { code: 'or', name: 'Oregon', image: require('@/assets/flags/us/or.png') },
            { code: 'pa', name: 'Pennsylvania', image: require('@/assets/flags/us/pa.png') },
            { code: 'ri', name: 'Rhode Island', image: require('@/assets/flags/us/ri.png') },
            { code: 'sc', name: 'South Carolina', image: require('@/assets/flags/us/sc.png') },
            { code: 'sd', name: 'South Dakota', image: require('@/assets/flags/us/sd.png') },
            { code: 'tn', name: 'Tennessee', image: require('@/assets/flags/us/tn.png') },
            { code: 'tx', name: 'Texas', image: require('@/assets/flags/us/tx.png') },
            { code: 'ut', name: 'Utah', image: require('@/assets/flags/us/ut.png') },
            { code: 'va', name: 'Virginia', image: require('@/assets/flags/us/va.png') },
            { code: 'vt', name: 'Vermont', image: require('@/assets/flags/us/vt.png') },
            { code: 'wa', name: 'Washington', image: require('@/assets/flags/us/wa.png') },
            { code: 'wi', name: 'Wisconsin', image: require('@/assets/flags/us/wi.png') },
            { code: 'wv', name: 'West Virginia', image: require('@/assets/flags/us/wv.png') },
            { code: 'wy', name: 'Wyoming', image: require('@/assets/flags/us/wy.png') },

            /* Bundesländer */
            { code: 'badenwurttemberg', name: 'Baden‑Württemberg', image: require('@/assets/flags/de/badenwurttemberg.png') },
            { code: 'bayern', name: 'Bayern', image: require('@/assets/flags/de/bayern.png') },
            { code: 'berlin', name: 'Berlin', image: require('@/assets/flags/de/berlin.png') },
            { code: 'brandenburg', name: 'Brandenburg', image: require('@/assets/flags/de/brandenburg.png') },
            { code: 'bremen', name: 'Bremen', image: require('@/assets/flags/de/bremen.png') },
            { code: 'hamburg', name: 'Hamburg', image: require('@/assets/flags/de/hamburg.png') },
            { code: 'hessen', name: 'Hessen', image: require('@/assets/flags/de/hessen.png') },
            { code: 'niedersachsen', name: 'Niedersachsen', image: require('@/assets/flags/de/niedersachsen.png') },
            { code: 'nrw', name: 'Nordrhein‑Westfalen', image: require('@/assets/flags/de/nrw.png') },
            { code: 'reihnlandpfalz', name: 'Rheinland‑Pfalz', image: require('@/assets/flags/de/reihnlandpfalz.png') },
            { code: 'saarland', name: 'Saarland', image: require('@/assets/flags/de/saarland.png') },
            { code: 'sachsen', name: 'Sachsen', image: require('@/assets/flags/de/sachsen.png') },
            { code: 'sachsenanhalt', name: 'Sachsen‑Anhalt', image: require('@/assets/flags/de/sachsenanhalt.png') },
            { code: 'schleswigholstein', name: 'Schleswig‑Holstein', image: require('@/assets/flags/de/schleswigholstein.png') },
            { code: 'thuringen', name: 'Thüringen', image: require('@/assets/flags/de/thuringen.png') }

        ];
        return {
            pool,
            score: 0,
            correct: null,
            options: [],
            currentImage: '',
            currentFallbackEmoji: '',
            feedback: null,
            selected: null,
            busy: false
        };
    },
    mounted() {
        this.nextRound();
        this.$refs.root && this.$refs.root.focus();
    },
    methods: {
        pickRandom() {
            return this.pool[Math.floor(Math.random() * this.pool.length)];
        },
        shuffleArray(a) {
            for (let i = a.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [a[i], a[j]] = [a[j], a[i]];
            }
            return a;
        },
        nextRound() {
            this.feedback = null;
            this.selected = null;
            this.busy = false;
            const chosen = this.pickRandom();
            this.correct = chosen;
            this.currentImage = chosen.image || '';
            // build options: correct + 3 random distinct others
            const others = this.pool.filter(p => p.name !== chosen.name);
            this.shuffleArray(others);
            const opts = [chosen.name].concat(others.slice(0, 5).map(o => o.name));
            this.options = this.shuffleArray(opts.slice());
        },
        choose(opt) {
            if (this.busy) return;
            this.selected = opt;
            this.busy = true;
            if (opt === this.correct.name) {
                this.feedback = 'correct';
                this.score++;
                if (this.score >= this.targetScore) {
                    // Emit done like other minigames; keep close() for manual escape.
                    setTimeout(() => this.$emit('done'), 300);
                    return;
                }
            } else {
                this.feedback = 'wrong';
            }
            // short delay then next round
            setTimeout(() => this.nextRound(), 700);
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.mini-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 15000;
}

.mini-card {
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    width: fit-content;
    max-width: 95%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mini-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.flag-area {
    width: 320px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0f172a;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
}

.flag-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    display: block;
}

.flag-fallback {
    font-size: 5rem;
    color: white;
}

.options {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-bottom: 8px;
}

.opt-btn {
    padding: 8px 12px;
    border-radius: 6px;
    border: 0;
    background: #2d3748;
    color: #fff;
    cursor: pointer;
    min-width: 140px;
}

.opt-btn.correct {
    background: #16a34a;
}

.opt-btn.wrong {
    background: #dc2626;
    opacity: 0.9;
}

.mini-close {
    background: transparent;
    border: 0;
    cursor: pointer;
    font-size: 16px
}

.mini-footer {
    font-size: 13px;
    color: #555;
    text-align: center;
}
</style>